var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecordCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.98014 1.33325C4.30014 1.33325 1.31348 4.31992 1.31348 7.99992C1.31348 11.6799 4.30014 14.6666 7.98014 14.6666C11.6601 14.6666 14.6468 11.6799 14.6468 7.99992C14.6468 4.31992 11.6668 1.33325 7.98014 1.33325ZM8.00014 10.8199C6.44014 10.8199 5.18014 9.55992 5.18014 7.99992C5.18014 6.43992 6.44014 5.17992 8.00014 5.17992C9.56014 5.17992 10.8201 6.43992 10.8201 7.99992C10.8201 9.55992 9.56014 10.8199 8.00014 10.8199Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordCircle);
export default __webpack_public_path__ + "static/media/RecordCircle.c3f5e73016b879cf72b7b4e413fce77c.svg";
export { ForwardRef as ReactComponent };